import React from "react"
import { AppDataTable } from "@components"
import { isTableLoading, tableData } from "Pages/Admin/OfficeMapping/@signals"
import { Skeleton } from "@mui/material"
import { actionsColumn, inputsColumn, siteColumn } from "Pages/Admin/OfficeMapping/Table/@columns"
import { useTableEdit } from "Pages/Admin/OfficeMapping/@hooks"


export default function OfficeMappingTable() {

	const { onSubmit } = useTableEdit()

	if (!tableData.value.length && !isTableLoading.value) return null

	if (isTableLoading.value) return <Skeleton height={500} variant="rectangular"/>


	return <AppDataTable
		title="Custom Offices Mapping"
		data={tableData.value}
		columns={[siteColumn(), inputsColumn(), actionsColumn(onSubmit)]}
	/>
}